import React from 'react'
import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe } from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";
import Title from '../layouts/Title';
import Card from './Card';

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"  
    >  
    
      <Title title="Features" des="My Expertise" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-10">
        <Card
          title="Backend & Automation Engineering"
          des="I design and operate scalable backend systems and automation pipelines using Node.js, TypeScript, Python, and PostgreSQL. My work focuses on event-driven architectures, background jobs, retries, failure recovery, and production-grade APIs."
        />
        <Card
          title="AI-Driven Workflow Automation"
          des="I build AI-powered automation systems that handle content generation, rewrites, approvals, publishing, and reporting. These workflows run on schedules or events, eliminating manual effort and significantly improving speed and efficiency."
        />
        <Card
          title="Event-Driven Systems & Job Queues"
          des="I develop reliable background processing systems using BullMQ and Redis, managing long-running tasks, retries, scheduling, and monitoring to ensure high success rates in production environments."
        />
        <Card
          title="Database & Data Engineering"
          des="I design, manage, and optimize relational databases using PostgreSQL and MySQL. My focus is on structured data pipelines, query optimization, data integrity, and secure, high-performance storage."
        />
        <Card
          title="Web Scraping & Data Collection"
          des="I build robust web scraping systems using Python to extract structured data from static and JavaScript-heavy websites, handling rate limiting, IP blocking, proxy rotation, headless browsers, and API integrations."
        />
        <Card
          title="Full Stack Development"
          des="I develop full-stack web applications using Django, React, JavaScript, HTML, and CSS, ensuring clean architecture, responsive interfaces, and seamless frontend-backend integration."
        />
        <Card
          title="DevOps, Deployment & Infrastructure"
          des="I deploy and manage production systems using Docker, background workers, and environment-based configurations, focusing on uptime, monitoring, logging, and smooth, reliable releases."
        />
        <Card
          title="Version Control & Collaboration"
          des="I use Git for structured version control, clean commit histories, and effective collaboration, enabling safe feature development and maintenance in fast-moving production systems."
        />
      </div>
    </section>
  );
}

export default Features